import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { pick } from 'lodash';

import GooglePlaces from 'js/services/GooglePlaces';
import AddressInputState from 'js/stores/AddressInputState';

import InputContainer from './InputContainer';
import Status from './Status';
import Suggestions from './Suggestions';
import Input from './Input';
import Container from './Container';
import { action, observable } from 'mobx';

@observer
export default class AddressInput extends Component {
  @observable addressInput = AddressInputState.create();

  // @action setAddressInput = (address) => {
  //   console.log('setAddressInput action', address);
  //   this.addressInput.setAddressInput(address)
  // };

  constructor(props) {
    super(props);
    let address = props.address;
    if (address && !address.formatted_address && !props.noAutoFill) {
      const localStorageAddress = JSON.parse(localStorage.getItem('primary_address'));
      address = window.app.currentUser ? window.app.currentUser.address || localStorageAddress : localStorageAddress;
    }

    this.setAddress(address, false);
  }

  // componentWillReceiveProps = props => {
  //   console.log('receive props', props);
  //   //if(props.address && !props.address.formatted_address){
  //     this.setAddress(props.address);
  //   //}
  // };

  setAddress = (address = null, saveAddress = true) => {
    saveAddress && localStorage.setItem('primary_address', JSON.stringify(address));
    this.addressInput.setAddressInput((address || {}).formatted_address || '').clearSuggestions();
    this.triggerOnChange(address);
  };

  onInputChange = event => {
    const addressInput = this.addressInput;
    this.triggerOnChange();
    const oldAddress = addressInput.addressInput;
    addressInput.setAddressInput(event.target.value);

    clearTimeout(this.addressChangeTimeout);
    this.addressChangeTimeout = setTimeout(
      () => {
        if (addressInput.addressInput && addressInput.addressInput.length > 4) {
          addressInput.clearPlaceId();
          this.fillSuggestions();
        }
      },
      addressInput.addressInput.length - oldAddress.length > 4 ? 0 : 300,
    );
  };

  triggerOnChange = (address = null) => this.props.onChange(address);

  getPlacesData = promise => {
    const addressInput = this.addressInput;

    addressInput
      .clearSuggestions()
      .setRequestInProgress(true)
      .setError(false);

    promise
      .then(() => addressInput.setRequestInProgress(false))
      .catch(() => {
        addressInput.setRequestInProgress(false).setError(true);
      });

    return promise;
  };
  fillSuggestions = () =>
    this.getPlacesData(GooglePlaces.getSuggestions(this.addressInput.addressInput)).then(places => {
      this.addressInput.setSuggestions(places.map(place => pick(place, ['description', 'place_id'])));
      if (this.addressInput.hasOneSuggestion) {
        this.selectSuggestion(this.addressInput.suggestions[0].place_id);
      }
    });
  selectSuggestion = placeId =>
    this.getPlacesData(GooglePlaces.placeAddress(this.addressInput.setPlaceId(placeId))).then(this.setAddress);

  render() {
    const { className, showError, name, id, placeholder, visible, address } = this.props;
    let addressInput = this.addressInput;
    // console.log('addressInput', this.addressInput, 'this.props', this.props);
    return (
      <Container>
        <InputContainer showError={showError} style={{ display: visible || 'block'}}>
          <Input
            className={className}
            id={id}
            name={name}
            hasSuggestions={addressInput.hasSuggestions || addressInput.requestInProgress}
            value={addressInput.addressInput}
            onChange={this.onInputChange}
            placeholder={placeholder || 'Street address'}
            autoFocus
          />
          <Status
            forId={id}
            spinner={addressInput.requestInProgress}
            showError={showError}
            hasAddress={this.props.address.hasAddress}
          />
        </InputContainer>

        <Suggestions
          value={addressInput.placeId}
          onChange={this.selectSuggestion}
          suggestions={addressInput.suggestions}
          isLoading={addressInput.requestInProgress}
          hasRequestError={addressInput.errorGettingPlacesData}
        />
      </Container>
    );
  }
}
